import React, { createContext, useContext, useState } from "react";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import { v4 as uuid } from "uuid";

const AlertContext = createContext();

export const useAlert = () => {
  const context = useContext(AlertContext);
  if (!context) {
    throw new Error("useAlert must be used within an AlertProvider");
  }
  return context;
};

export const AlertProvider = ({ children }) => {
  const [alertProps, setAlertProps] = useState([]);

  const showAlert = (message, severity, duration) => {
    const newAlert = { message, severity, show: true, id: uuid() };
    setAlertProps((prevAlerts) => [...prevAlerts, newAlert]);
    if (duration !== 0) {
      setTimeout(() => {
        handleAlertClose(null, null, newAlert.id);
      }, duration);
    }
  };

  const handleAlertClose = (event, reason, id) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertProps((prevAlerts) => prevAlerts.filter((alert) => alert.id !== id));
  };

  return (
    <AlertContext.Provider value={{ showAlert, handleAlertClose }}>
      <Stack
        sx={{
          position: "fixed",
          top: "1rem",
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 9999,
        }}
        spacing={2}>
        {alertProps.map((alert) => (
          <Alert variant="filled" key={alert.id} severity={alert.severity} onClose={(event, reason) => handleAlertClose(event, reason, alert.id)}>
            {alert.message}
          </Alert>
        ))}
      </Stack>
      {children}
    </AlertContext.Provider>
  );
};
